import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Form from "../Helpers/Form/Form";
import { popupcontext } from "../../context/Popupscontext";
import trans, { isRTL } from "../../utils";
import FormHeader from "../Helpers/Form/FormParts/FormHeader";
import { Offcanvas } from "react-bootstrap";
import Loader from "../Helpers/Loader/Loader";
import OffcanvasFooter from "../Helpers/Offcanvasfooter/OffcanvasFooter";
import {
	useEditPOIMutation,
	useGetSpecificPOIQuery,
} from "../../Redux/service/POIS/POIs";
import ProjectsetupInfo from "./ProjectsetupInfo";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
export default function ProjectsetupForm() {
	const {
		form,
		isEditing,
		currentPOIId,
		handleClose,
		setReloadData,
		setIsEditing,
		attachmentsId,
		setAttachmentsId,
	} = useContext(popupcontext);
	const {
		data: Editvalues,
		refetch,
		isLoading: valuesLoading,
	} = useGetSpecificPOIQuery(currentPOIId, {
		skip: !currentPOIId,
	});
	const [poiAttachments, setPoiAttachments] = useState();

	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [EditPOI, { isLoading: editLoading }] = useEditPOIMutation();
	let initialValues = {
		name: null,
		status: true,
		type: "project", // project , building , level , space
		latitude: 0,
		longitude: 0,
		address: null,
		notes: null,
		country: ".",
		state: ".",
		city: ".",
		contactPerson: {
			name: null,
		},
		customAttributes: null,
		attachments: [],
		attachmentsToDelete: null,
		parentId: null,
		contractorLogo: null,
		contractorLabel: null,
		customer1Logo: null,
		customer1Label: null,
		customer2Logo: null,
		customer2Label: null,
		consultantLogo: null,
		consultantLabel: null,
		projectType: null, // project
		projectStatus: null, // project
		startDate: null, // projcet
		endDate: null, // project
		coordinates: null, // building,level,space
		forms: [],
		formCategory: null,
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.test(
				"not-empty-or-spaces",
				trans("Name cannot be just whitespace"),
				(value) => !!value && value.trim().length > 0,
			),
		type: Yup.string().required(trans("Type is required")),
		formCategory: Yup.string().required(trans("Form category is required")),
		forms: Yup.string().required(trans("Form is required")),
		notes: Yup.string()
			.optional()
			.nullable()
			.test(
				"not-whitespace-only",
				trans("Notes cannot be just whitespace"),
				(value) => {
					if (value === null || value === undefined || value === "")
						return true; // allow empty
					return value.trim().length > 0; // disallow only whitespace
				},
			),
		contactPerson: Yup.object()
			.shape({
				name: Yup.string()
					.nullable()
					.min(3, trans("Name must be at least 3 characters"))
					.test("not-empty", trans("Name cannot be just whitespace"), (val) => {
						if (!val) return true;
						return val.trim().length > 0;
					}),
			})
			.test(
				"all-or-none",
				trans("If any contact person field is filled, all must be provided"),
				function (value) {
					if (!value) return true;
					const { name } = value;
					const anyFilled = name;
					const allFilled = !!name?.toString().trim();
					// If one is filled but not all → error
					if (anyFilled && !allFilled) {
						return this.createError({
							message: trans(
								"All contact person fields are required if one is filled",
							),
						});
					}
					return true;
				},
			)
			.nullable(),
	});
	let addPOI = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val, helpers) => {
			try {
				if (isEditing) {
					delete val.createdAt;
					delete val.updatedAt;
					delete val.createdBy;
					delete val.updatedBy;
					delete val.createdById;
					delete val.updatedById;
					delete val.parent;
					delete val.code;
					delete val.id;
					if (val.geofenced === false) {
						delete val.area;
						delete val.diameter;
					}
					if (val.type === "project" && val.parentId) {
						delete val.parentId;
					}
					await EditPOI({
						id: currentPOIId,
						val: val,
					}).unwrap();
					refetch();
					handleClose("form");
					setSubmitAttempt(false);
					setPoiAttachments([]);
					toast.success(trans("POI Is Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				}

				setIsEditing(false);
				setSubmitAttempt(false);
				setReloadData(true);
			} catch (error) {
				console.log(error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addPOI.handleSubmit(e);
	};
	const ranOnce = useRef(false);

	useEffect(() => {
		if (!ranOnce.current && addPOI?.values?.attachments?.length > 0 && form) {
			setPoiAttachments(addPOI.values.attachments);
			ranOnce.current = true;
		}
	}, [addPOI?.values?.attachments, form]);

	useEffect(() => {
		if (form === false) {
			addPOI.resetForm();
			ranOnce.current = false;
			setAttachmentsId([]);
		}
	}, [form]);
	useEffect(() => {
		if (isEditing && Editvalues) {
			const data = Editvalues.data;

			addPOI.setValues({
				...data,
				forms: Array.isArray(data.forms)
					? (data.forms[0]?.formId ?? null)
					: (data.forms ?? null),
				formCategory: Array.isArray(data.forms)
					? (data.forms[0]?.form?.category ?? null)
					: (data.forms ?? null),
			});
		} else if (!isEditing) {
			addPOI.resetForm(); // Clear form when not editing
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, Editvalues]);
	useEffect(() => {
		if (attachmentsId && isEditing) {
			addPOI.setFieldValue("attachmentsToDelete", attachmentsId);
		}
	}, [attachmentsId, isEditing]);
	console.log("VAL", addPOI);
	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader title={isEditing && trans("Edit Project Setup")} />
				</Offcanvas.Header>
				<Offcanvas.Body>
					<form onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
						{editLoading ? (
							<div className="loader-container">
								<Loader />
							</div>
						) : (
							<ProjectsetupInfo
								addPOI={addPOI}
								poiAttachments={poiAttachments}
							/>
						)}
						<OffcanvasFooter addData={addPOI} submitAttempt={submitAttempt} />
					</form>
				</Offcanvas.Body>
			</Form>
		</>
	);
}
